import React from 'react';
import { Box, Grid, Typography, Link } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { useTranslation } from '../hooks/useTranslation';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: '#099FBE',
        padding: 4,
        textAlign: 'center',
        alignContent: 'center',
        marginTop: 'auto',
        color: 'white'
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">{t('footer.location')}</Typography>
          <Typography variant="body1"><b>{t('footer.address')}:</b></Typography>
          <Typography>
            {t('footer.street')}<br />
            {t('footer.email')}
          </Typography>
          <Typography>
            <Link href="tel:+46704433299" color="inherit">
              <PhoneIcon sx={{ marginRight: 1 }} />
              +46 70 44 33 2 99
            </Link>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body1"><b>{t('footer.directions')}:</b></Typography>
          <Typography>{t('footer.directionsCar')}</Typography>
          <Typography>{t('footer.directionsBus')}</Typography>
          
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;